import React from 'react';
import { DumboProps } from '../types';
import classnames from 'classnames';
import ImageIcon from '@wix/da-ds/pkg/Icons/32x32/AddImage';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import { MAX_WIDTH_FOR_TOOLTIP } from './constants';
import s from './Unknown.scss';

export type Props = Optional<DumboProps, 'deviation'>;
const UnknownDumbView: React.FC<Props> = ({
  width,
  height,
  className,
  'aria-hidden': ariaHidden,
}) => {
  const { t } = useTranslation();
  return width && width > MAX_WIDTH_FOR_TOOLTIP ? (
    <div
      style={{ width, height }}
      className={classnames(className, s['root'])}
      aria-hidden={ariaHidden}
    >
      <div>
        <ImageIcon size={IconSize.BIG} className={s['imageicon']} />
      </div>
      <div className={s['nopreview']}>
        {t('deviationview.unknown.nopreview')}
      </div>
    </div>
  ) : (
    <TextTooltipOnHover tooltipText={t('deviationview.unknown.nopreview')}>
      <div
        style={{ width, height }}
        className={classnames(className, s['root'])}
        aria-hidden={ariaHidden}
      >
        <div>
          <ImageIcon size={IconSize.BIG} className={s['imageicon']} />
        </div>
      </div>
    </TextTooltipOnHover>
  );
};

export default UnknownDumbView;
